import { Stack } from 'expo-router';

import { FloatingViewCartFab } from 'components/floating-view-cart-fab';
import { primitive } from 'styles/constants';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function MenuLayout() {
  return (
    <>
      <Stack
        screenOptions={{
          contentStyle: { backgroundColor: primitive.$mayoEggWhite },
          headerShown: false,
        }}
      >
        <Stack.Screen name="index" options={{ animation: 'none' }} />
        <Stack.Screen name="favorites" options={{ animation: 'none' }} />
        <Stack.Screen name="recent-items" options={{ animation: 'none' }} />
        {/* NOTE: modals are in (modals), section pages are in /menu/section for non-tabbed presentation */}
      </Stack>
      <FloatingViewCartFab />
    </>
  );
}
